var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 41,
    height: 27.871,
    rx: 5,
    stroke: "#5062F0",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1897,
    y: 20.9678,
    width: 0.849057,
    height: 4.19355,
    fill: "#5062F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9631,
    y: 20.9678,
    width: 0.849057,
    height: 4.19355,
    fill: "#5062F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0765,
    y: 20.9678,
    width: 0.849057,
    height: 4.19355,
    fill: "#5062F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0765,
    y: 25.834,
    width: 0.849057,
    height: 3.69828,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0284 26C10.5652 26 10.1897 25.6245 10.1897 25.1613H34.8123C34.8123 25.6245 34.4368 26 33.9736 26H11.0284Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80432 10.2256C6.80432 9.6733 7.25204 9.22559 7.80432 9.22559H12.0579H13.4458C13.9981 9.22559 14.4458 9.6733 14.4458 10.2256V12.1611V19.9675C14.4458 20.5198 13.9981 20.9675 13.4458 20.9675H7.80432C7.25204 20.9675 6.80432 20.5198 6.80432 19.9675V10.2256Z",
    stroke: "#5062F0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23669 12.0127L13.0051 12.0127",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23669 14.8486L13.0051 14.8486",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23669 17.6846H13.0051",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.578 10.2256C30.578 9.6733 31.0257 9.22559 31.578 9.22559H35.8315H37.2195C37.7718 9.22559 38.2195 9.6733 38.2195 10.2256V12.1611V19.9675C38.2195 20.5198 37.7718 20.9675 37.2195 20.9675H31.578C31.0257 20.9675 30.578 20.5198 30.578 19.9675V10.2256Z",
    stroke: "#5062F0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0103 12.0127L36.7788 12.0127",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0103 14.8486L36.7788 14.8486",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0103 17.6846H36.7788",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6911 10.2256C18.6911 9.6733 19.1388 9.22559 19.6911 9.22559H23.9447H25.3326C25.8849 9.22559 26.3326 9.6733 26.3326 10.2256V12.1611V19.9675C26.3326 20.5198 25.8849 20.9675 25.3326 20.9675H19.6911C19.1388 20.9675 18.6911 20.5198 18.6911 19.9675V10.2256Z",
    stroke: "#5062F0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1235 12.0127L24.8919 12.0127",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1235 14.8486L24.8919 14.8486",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1235 17.6846H24.8919",
    stroke: "#5062F0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6132 38.3223C10.6132 37.77 11.0609 37.3223 11.6132 37.3223H33.3868C33.939 37.3223 34.3868 37.77 34.3868 38.3223V38.9997H10.6132V38.3223Z",
    fill: "#5062F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0393 33.8383C18.1672 33.417 18.5558 33.1289 18.9961 33.1289H26.0039C26.4442 33.1289 26.8328 33.417 26.9607 33.8383L28.0189 37.3225H16.9811L18.0393 33.8383Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationIconBlue);
export default __webpack_public_path__ + "static/media/operationIconBlue.45ec954d3374feb7d8e0321ae32618dc.svg";
export { ForwardRef as ReactComponent };